export default {
  csatText: 'CSAT consolidado',
};
